import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top">
      <Link className="navbar-brand logo-image" to="/">
        <img src="images/logo.svg" alt="alternative" />
      </Link>

      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarsExampleDefault"
        aria-controls="navbarsExampleDefault"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-awesome fas fa-bars"></span>
        <span className="navbar-toggler-awesome fas fa-times"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarsExampleDefault">
        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <a className="nav-link page-scroll" href="#feature">
              FEATURE
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link page-scroll" href="#description">
              DESCRIPTION
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link page-scroll" href="#takeaways">
              TAKE A WAY
            </a>
          </li>

          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle page-scroll"
              href="#date"
              id="navbarDropdown"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              PAGES
            </a>
            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
              <Link className="dropdown-item" to="/article-details">
                <span className="item-text">ARTICLE DETAILS</span>
              </Link>
              <div className="dropdown-divider"></div>
              <Link className="dropdown-item" to="/terms-conditions">
                <span className="item-text">TERMS CONDITIONS</span>
              </Link>
              <div className="dropdown-divider"></div>
              <Link className="dropdown-item" to="/privacy-policy">
                <span className="item-text">PRIVACY POLICY</span>
              </Link>
            </div>
          </li>

          <li className="nav-item">
            <a className="nav-link page-scroll" href="#contact">
              CONTACT
            </a>
          </li>
          <li className="nav-item">
            <Link className="nav-link page-scroll" to="/login">
              LOGIN
            </Link>
          </li>
          <li className="nav-item">
            <Link className="nav-link page-scroll" to="/register">
              REGISTER
            </Link>
          </li>
        </ul>
        <span className="nav-item social-icons">
          <span className="fa-stack">
            <a href="#your-link">
              <i className="fas fa-circle fa-stack-2x"></i>
              <i className="fab fa-facebook-f fa-stack-1x"></i>
            </a>
          </span>
          <span className="fa-stack">
            <a href="#your-link">
              <i className="fas fa-circle fa-stack-2x"></i>
              <i className="fab fa-twitter fa-stack-1x"></i>
            </a>
          </span>
        </span>
      </div>
    </nav>
  );
};

export default Navbar;
